module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1080.300b9b3f.png";